<template>
  <div class="m-wrapper">
    <div class="title">
      <p class="title-text">注册账户</p>
    </div>
    <div class="main">
      <div class="main-input">
        <van-cell-group>
          <van-field
            v-model="regInfo.account"
            clearable
            type="number"
            label="设置账户:"
            right-icon="question-o"
            placeholder="设置用户名（手机号）"
            @click-right-icon="$toast('请使用常用手机号作为用户名！')"
            autocomplete="off"
          />
          <van-field
            v-model="regInfo.password"
            type="password"
            label="设置密码:"
            right-icon="question-o"
            placeholder="设置您的登录密码"
            @click-right-icon="$toast('密码为6位以上数字或字符！')"
            autocomplete="off"
          />
          <van-field
            v-model="regInfo.password_confirm"
            type="password"
            label="重复密码:"
            right-icon="question-o"
            placeholder="请再次输入您的密码"
            @click-right-icon="$toast('重复上述密码，防止出错！')"
            autocomplete="off"
          />
          <van-field
            v-model="regInfo.full_name"
            label="真实姓名:"
            right-icon="question-o"
            placeholder="请输入真实姓名"
            @click-right-icon="$toast('输入真实姓名便于管理员核对并授予权限！')"
            autocomplete="off"
          />
        </van-cell-group>

        <button class="m-bt" @click="toRegister">同意条款并注册</button>
      </div>
      <p class="link-login">
        <router-link :to="{name:'login'}">已有帐号，去登录</router-link>
      </p>
      <p class="seti policy">
        注册即代表您已同意
        <a href="/user/policy" class="c-378BD3">srccLims注册协议与隐私政策</a>
      </p>
    </div>
  </div>
</template>
<script>
function isPasswd(s) {
  var patrn = /^([A-Za-z0-9_]){6,20}$/;
  if (!patrn.test(s)) return false;
  return true;
}
export default {
  name: "registerBox",
  data() {
    return {
      regInfo: {
        account: "",
        password: "",
        password_confirm: "",
        full_name: ""
      }
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    checkVal() {
      if (this.regInfo.account == "") {
        this.$toast("用户名不能为空!");
        return false;
      } else if (this.regInfo.password == "") {
        this.$toast("密码不能为空!");
        return false;
      } else if (this.regInfo.password_confirm == "") {
        this.$toast("请再次输入密码！");
        return false;
      } else if (this.regInfo.password_confirm !== this.regInfo.password) {
        this.$toast("两次密码不同请重新设置！");
        this.regInfo.password_confirm = "";
        this.regInfo.password = "";
        return false;
      } else if (this.regInfo.full_name === "") {
        this.$toast("真实姓名不能为空！");
        return false;
      } else if (
        this.regInfo.account.length <= 4 ||
        this.regInfo.account.length > 17
      ) {
        this.$toast("用户名长度应为5～17位");
        return false;
      } else if (
        this.regInfo.password.length <= 5 ||
        this.regInfo.password.length > 20
      ) {
        this.$toast("密码长度不符合要求!");
        return false;
      } else if (!isPasswd(this.regInfo.password)) {
        this.$toast("密码只能包含字母、数字、下划线，请重新设置!");
        return false;
      }else{
        return true;
      }
    },
    toRegister() {
      if (this.checkVal()) {
        this.$axios
          .post(this.$url + "/register", {
            val: this.regInfo
          })
          .then(response => {
            if (response.data.error_info !== "") {
              this.$toast(response.data.error_info);
            } else {
              this.$toast("注册成功！");
              location.href = "/login";
            }
          })
          .catch(error => {
            this.$toast(error + "注册失败！");
          });
      }
    }
  }
};
</script>


<style scoped>
.m-wrapper {
  text-align: center;
  min-height: 460px;
}
.main {
  width: 90%;
  margin: 0 auto;
}
.title-text {
  text-align: center;
  font-size: 25px;
  font-weight: 800;
  color: #000;
  padding: 30px 0 50px 0;
}

.regi {
  border: 1px solid #003e94;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  height: 2.1rem;
  font-size: 0.85rem;
  line-height: 2.1rem;
  font-weight: 700;
}

.m-bt {
  width: 100%;
  margin: 1rem auto 0;
  outline: none;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  height: 2.25rem;
  font-size: 0.85rem;
  line-height: 2.25rem;
  background: #aa3702;
  color: #fff;
}
.forget-p {
  font-size: 0.85rem;
  text-align: right;
}

.policy {
  font-size: 0.3rem;
}

.policy a {
  color: blue;
}
.link-login {
  font-size: 0.6rem;
  text-align: right;
  padding-right: 0.5rem;
  margin: 0.8rem 0;
}

input:internal-autofill-selected {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
</style>